module.exports = __webpack_public_path__ + "static/Moonlighter1-9769c6448236ded84fa823ad34353a47.webp";